import type { LoaderFunction } from "react-router-dom";
import Session from "supertokens-auth-react/recipe/session";

export const checkSessionLoader: LoaderFunction = async ({ request }) => {
  const sessionExists = await Session.doesSessionExist();

  if (!sessionExists) {
    const redirectUrl = new URL(request.url);

    const returnTo = redirectUrl.pathname + redirectUrl.search;
    const redirectTo = `/auth?redirectTo=${encodeURIComponent(returnTo)}`;
    return new Response(null, { status: 302, headers: { Location: redirectTo } });
  }

  const userId = await Session.getUserId();

  return { userId };
};
